module.exports = __webpack_public_path__ + "img/l.dfa2e509.png";